/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SlowMovingInventoryAnalysis {
  angular.module("meevo.plugins.slowMovingInventoryAnalysis", []);
}
